import { useEffect, useState } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addMovies,
  getMovieById,
  updateMovie,
} from "../store/actions/moviesActions";
import FormMovies from "./FormMovies";

export default function AddMovie() {
  
  const { movie, loadingUpdate } = useSelector((state) => state.moviesReducer);
  const { state } = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (state) {
      dispatch(getMovieById(id));
    }
  }, []);

  return (
    <>{state ? 
      loadingUpdate ? (
        <h3>Loading Page </h3>
      ) : ( 
        // JSON.stringify(movie)
        <FormMovies movie={movie} state={state}/>
      ) : 

      <FormMovies/>
    }
    </>
  );
}
